const { paramsForServer } = require('feathers-hooks-common')

/**
 * Set project and integration info
 * so its in a stand format for the api
 */

export default {
  before: {
    all: context => {
      context.params = paramsForServer(context.params)
      return context
    }
  }
}
